<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text">
      <v-img class="ml-2" src="/img/icons/profit_icon.svg" max-width="30"></v-img>
      حاشیه سود <span
        :class="(report_type==='gross')?'ml-1 mr-1 info--text':'ml-1 mr-1 success--text'">{{ title }}</span> ماهانه
      <v-spacer></v-spacer>
      <chart-export-btn :page-chart-id="chart_id"></chart-export-btn>
    </v-card-title>
    <canvas height="120" :id="chart_id"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'NetInterestMarginChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: ["آبان"],
          datasets: [
            {
              label: "",
              data: [150000, 300000, 220000, 150000, 300000, 250000, 100000, 85000],
              backgroundColor: "rgba(50, 168, 82,.08)",
              borderColor: "#50CD89",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
          ]
        },

        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' %  ';
                } else {
                  label += tooltipItem.yLabel + ' % ';
                }
                return label
              },
            },
          },

          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .08)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' % ';
                    } else {
                      return value + ' % ';
                    }
                  }

                }
              }
            ]
          }
        }
      }
    }
  },
  props: {
    report_type: {
      default: 'net',
    },
  },
  methods: {
    setChartStyle() {
      if (this.report_type == 'gross') {
        this.setGrossChartColors()
      }
    },

    setGrossChartColors() {
      this.chartData.data.datasets[0].backgroundColor = "rgba(1, 158, 246,.04)";
      this.chartData.data.datasets[0].borderColor = '#019EF6'
      this.chartData.data.datasets[0].label = `${this.title}  حاشیه سود `

    },

    getChartFromApi() {
      this.request({
        url: this.endpoint(`reports/pureProfitByMonthChartReport/${this.report_type}`),
        method: "get",
        success: data => {
          this.setData(data)
        }
      })
    },

    setData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize = 13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let month of data) {
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.profitPercent)

      }

      this.setChart()
    },
    setChart() {
      this.setChartStyle()
      const ctx = document.getElementById(`${this.chart_id}`);
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  },
  computed: {
    chart_id() {
      if (this.report_type == 'net') {
        return 'n-i-m-chart'
      } else {
        return 'g-i-m-chart'
      }
    },
    title() {
      if (this.report_type == 'net') {
        return 'خالص'
      } else {
        return 'نا خالص'
      }
    },
  },
}
</script>